<template>
  <div id="chart-box">
    <div id="chart-area"></div>
  </div>
</template>

<script>
import tuiChart from "tui-chart";

export default {
  props: {
    scriptId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      source: [],

      options: {
        chart: {
          width: 800,
          height: 540,
          title: "脚本信息统计",
        },
        yAxis: {
          title: "次数",
          min: 0,
        },
        xAxis: {
          title: "日期",
        },
        legend: {
          align: "top",
        },
      },
    };
  },
  computed: {
    installSource() {
      const buffer = [];
      for (const item of this.source) {
        for (const [, statistics] of Object.entries(item)) {
          buffer.push(statistics.install);
        }
      }
      return buffer;
    },
    updateSource() {
      const buffer = [];
      for (const item of this.source) {
        for (const [, statistics] of Object.entries(item)) {
          buffer.push(statistics.update);
        }
      }
      return buffer;
    },
    categories() {
      const buffer = [];
      for (const item of this.source) {
        for (const [date] of Object.entries(item)) {
          buffer.push(date);
        }
      }
      return buffer;
    },
  },
  watch: {
    source() {
      this.renderChart();
    },
  },
  methods: {
    async getStatistics() {
      const response = await this.axios.get(
        `/api/queryHistoryById/${this.scriptId}`
      );

      switch (response.data.code) {
        case 200: //发送成功后返回
          {
            const temp = response.data.data;
            this.source = temp.slice(
              temp.length - 30 >= 0 ? temp.length - 30 : 0,
              temp.length
            );
          }
          break;

        case -100:
          this.$message({
            message: "统计信息获取失败",
            type: "error",
          });
          break;
      }
    },
    renderChart() {
      const container = document.getElementById("chart-area");
      const data = {
        categories: this.categories,
        series: [
          {
            name: "安装",
            data: this.installSource,
          },
          {
            name: "更新",
            data: this.updateSource,
            // data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 1, 2, 3, 4, 5, 6, 7, 8],
          },
        ],
      };

      this.options.yAxis.max = Math.max(
        ...this.installSource,
        ...this.updateSource
      );

      // const theme = {
      //   series: {
      //   //   colors: [
      //   //     "#295ba0",
      //   //     "#2a4175",
      //   //     "#289399",
      //   //     "#289399",
      //   //     "#617178",
      //   //     "#8a9a9a",
      //   //     "#516f7d",
      //   //     "#dddddd",
      //   //   ],
      //   // },
      // };
      // // For apply theme
      // tuiChart.registerTheme("myTheme", theme);
      // this.options.theme = "myTheme";

      tuiChart.columnChart(container, data, this.options);
    },
  },
  created() {
    this.getStatistics();
  },
};
</script>

<style scoped>
#chart-box {
  display: flex;
  justify-content: center;
}
</style>
